<template>
  <div class="assest-page " >
    
    <div class="statistics-box">
      <div class="flex-center-start label">
        <span>{{i18n.t(`account.label1_${pageType}`)}}({{bitName}})</span>
        <img :src="showMoney ? eyeUrl2 : eyeUrl" alt="" @click="changeMoneyType">
      </div>

      <div class="flex-end-start money-info" >
        <div class="total flex-end-start">{{moneyStr}}</div>
        <div class="desc flex-end-start">≈ {{showMoney ?  parseFloat(bitMoney).toFixed(4) : '****'}} {{currencyVal}}</div>
      </div>


      <div class="flex today-static">
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{i18n.t(`account.label2_${pageType}`)}}({{bitName}})</div>
          <div class="count">{{freeMoney}}</div>
        </div>
        <div class="flex-1 flex-column-start-center">
          <div class="name">{{i18n.t(`account.label3`)}}({{bitName}})</div>
          <div class="count" >{{moneyUse}}</div>
        </div>
      </div>
    </div>

    <div class="tab-list flex-center-start">
      <div class="tab flex-column-center" @click="toPath('recharge')">
        <img :src="rechargeUrl" alt="">
        <span>{{i18n.t('assest.label2')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toWithdraw">
        <img :src="withdrawUrl" alt="">
        <span>{{i18n.t('assest.label3')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toTransfer">
        <img :src="transferUrl" alt="">
        <span>{{i18n.t('assest.label4')}}</span>
      </div>
      <div class="tab flex-column-center" @click="toLog">
        <img :src="debtUrl" alt="">
        <span>{{i18n.t(`assest.label5_${pageType}`)}}</span>
      </div>
    </div>

    

    <!--现货-->
    <div class="account-table" v-if="pageType == 3">
      <div class="space-line"></div>

      <div class="title">{{ $t('xian-huo-zi-chan') }}</div>

      <div class="list-table clear-bg">
        <div class="th-line flex-center-between">
          <div class="th flex-2">{{ $t('transfer.label3') }}</div>
          <div class="th flex-2">{{ $t('trade.label65') }}</div>
          <div class="th flex-2">{{ $t('trade.label66') }}</div>
          <div class="th flex-2">{{ $t('trade.label3') }}</div>
          <div class="th action">{{ $t('cao-zuo') }}</div>
        </div>
        <div class="tbody">
          <div class="td-line flex-center-between" v-for="(item, i) in bitList" :key="i" >
            <div class="td flex-2 flex-center-start">
              <img :src="`/upload/${item.Currency.Logo}`" alt="">
              <span>{{item.Currency.ShortName}}</span>
            </div>
            <div class="td flex-2">${{resetBitMoney(parseFloat(item.SpotUse) + parseFloat(item.SpotFree), item.Currency.ShortName)}}</div>
            <div class="td flex-2">${{resetBitMoney(parseFloat(item.SpotFree), item.Currency.ShortName)}}</div>
            <div class="td flex-2">${{resetBitMoney(parseFloat(item.SpotUse), item.Currency.ShortName)}}</div>
            <div class="td action flex-center">
               <div class="btn" @click="toTrade(item, 1)">{{ $t('pageTitle.trade') }}</div>
            </div>
          </div>
        </div>
      </div>

      <pageBar :total="page.total" @changePage="changePage"></pageBar>
    </div>

    <!--合约-->
    <div class="account-table" v-if="pageType == 2">
      <div class="space-line"></div>

      <div class="title">{{ $t('he-yue-zi-chan') }}</div>

      <div class="list-table clear-bg">
        <div class="th-line flex-center-between">
          <div class="th flex-2">{{ $t('transfer.label3') }}</div>
          <div class="th flex-2">{{ $t('trade.label7') }}</div>
          <div class="th flex-2">{{ $t('trade.label65') }}</div>
          <div class="th action">{{ $t('cao-zuo-0') }}</div>
        </div>
        <div class="tbody">
          <div class="td-line flex-center-between" v-for="(item, i) in bitList" :key="i" >
            <div class="td flex-2 flex-center-start">
              <img :src="`/upload/${item.Currency.Logo}`" alt="">
              <span>{{item.Currency.ShortName}}</span>
            </div>
            <div class="td flex-2">${{item.TrustClose}}</div>
            <div class="td flex-2">${{resetBitMoney(parseFloat(item.ContractUse) + parseFloat(item.ContractFree), item.Currency.ShortName)}}</div>
            <div class="td action flex-center">
               <div class="btn" @click="toTrade(item, 3)">{{ $t('pageTitle.trade') }}</div>
            </div>
          </div>
        </div>
      </div>

      <pageBar :total="page.total" @changePage="changePage"></pageBar>
    </div>

    <!--金融-->
    
    <div class="account-table" v-if="pageType == 4">
      <div class="space-line"></div>

      <div class="title">{{ $t('finance.label2') }}</div>

      <div class="table-tabs flex">
        <div class="tab" :class="financeIndex == 1 ? 'active' : ''" @click="changeFinanceTab(1)">{{ $t('huo-qi-chan-pin') }}</div>
        <div class="tab" :class="financeIndex == 2 ? 'active' : ''" @click="changeFinanceTab(2)">{{ $t('ding-qi-chan-pin') }}</div>
      </div>

      <div class="list-table clear-bg">
        <div class="th-line flex-center-between">
          <div class="th flex-2">{{ $t('transfer.label3') }}</div>
          <div class="th flex-2">{{ $t('account.label2_4') }}</div>
          <div class="th flex-2">{{ $t('nian-hua-shuai') }}</div>
          <div class="th flex-2">{{ $t('financeBuy.label2') }}</div>
          <div class="th flex-2">{{ $t('finance.label4') }}</div>
          <div class="th action">{{ $t('cao-zuo-1') }}</div>
        </div>
        <div class="tbody">
          <div class="td-line flex-center-between" v-for="(item, i) in logList" :key="i" >
            <div class="td flex-2 flex-center-start">
              <img :src="item.FinancialSetup.Currency.Logo ? `/upload/${item.FinancialSetup.Currency.Logo}` : bitUrl" alt="">
              <span>{{item.FinancialSetup.Currency.Name}}</span>
            </div>
            <div class="td flex-2"><div>{{parseFloat(item.OrderAmount).toFixed(4)}}</div></div>
            <div class="td flex-2">{{item.FinancialSetup.IncomeRatio}}%</div>
            <div class="td flex-2">{{item.FinancialSetup.ProductType === 1 ? $t('finance.label13') : $t('finance.label14')}}</div>
            <div class="td flex-2">{{parseFloat(item.IncomeAmount).toFixed(2)}}</div>
            <div class="td action flex-center">
               <div class="btn" >{{ $t('shu-hui') }}</div>
            </div>
          </div>
        </div>
      </div>

      <pageBar :total="page.total" @changePage="changePage"></pageBar>
    </div>
  
    <!--跟单、期权-->
    
    <div class="account-echart" v-if="pageType == 6 || pageType == 1">
      <div class="sub-title">{{pageType == 1 ? $t('account.dailyReport1') : $t('account.dailyReport2')}}</div>
      <div class="account-chart-box" >
        <div class="echart-dom" id="chartDom1"></div>
      </div>
      <div class="sub-title">{{pageType == 1 ? $t('account.monthlyReport1') : $t('account.monthlyReport2')}}</div>
      <div class="account-chart-box small flex" >
        <div class="flex-1  border flex-column">
          <div class="chart-title">{{getTitle(true)}}</div>
          <div class="outer">
            <div class="echart-dom" id="chartDom2"></div>
          </div>
        </div>
        <div class="flex-1 flex-column">
          <div class="chart-title pl-20">{{getTitle(false)}}</div>
          <div class="outer">
            <div class="echart-dom" id="chartDom3"></div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import { Popup, Button, Search } from 'vant'
import { myAssets, wallet, allTrades, contractProfit, optionReport, contractOverview} from '@/api/assest'
import { monetaryList } from '@/api/index'
import { accountReport } from '@/api/trade'
import pageBar from '@/components/pageBar'
import { financeList } from '@/api/finance'
import * as echarts from 'echarts'
import moment from 'moment'
export default {
  components: {
    Popup,
    Button,
    Search,
    pageBar
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      bitUrl: require('../../assets/imgs/bit1.png'),
      backUrl: require('../../assets/imgs/icon-back.png'),
      closeUrl: require('../../assets/imgs/icon-close.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
      rechargeUrl: require('../../assets/imgs/icon-recharge.png'),
      withdrawUrl: require('../../assets/imgs/icon-withdraw.png'),
      transferUrl: require('../../assets/imgs/icon-transfer.png'),
      debtUrl: require('../../assets/imgs/icon-debt.png'),
      showMoney: true,
      userMoney: '0.00',
      freeMoney: '0.00',
      moneyUse: '0.00',
      bitName: 'USDT',
      bitId: '1',
      showBitPage: false,
      pageType: 1,
      showZero: true,
      bitList: [], 
      bitListBak: [],
      bitTabIndex: 1,
      // bitTabList: [this.i18n.t('account.tab5') ,this.i18n.t('account.tab6')],
      bitTabList: [this.i18n.t('account.tab5') ],
      bitTabList2: [this.i18n.t('account.tab8')],
      ownerFinanceList: [],
      allFinanceList: [],
      allRateList: [],
      isAllOk: false,
      isOwnOk: false,
      profitMoney: '0.00',
      profitBitMoney: '0.00000',
      allTradesData: [],
      todayProfit: '0.00',
      todayProfitBit: '0.00000',
      optionReportData: {
        TodayOptionOrder: {},
        MonthOptionOrder: {},
        LastMonthOptionOrder: {},
      },
      financeIndex: 1,
      page: {
				page: 1,
				limit: 10,
				total: 1
			},
			logList: [],
      chartDom1: '',
      chartDom2: '',
      chartDom3: ''
    }
  },
  computed: {
    moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    currencyVal() {
      return this.$store.state.currencyVal
    },
    currencyRate() {
      return this.$store.state.currencyRate
    },
    allBitList() {
      return this.$store.state.bitList
    },
    bitMoney() {
      if (this.userMoney) {
        return this.userMoney * this.currencyRate
      } else {
        return '0.0000'
      }
    }
  },
  mounted() {
    let type = this.$route.query.type
    this.pageType = type
    let bitName = localStorage.getItem('bitName')
    if (bitName) {
      this.bitName = bitName
      this.bitId = localStorage.getItem('bitId')
    }
   
    this.init()
    this.initWallet()
    this.initRate()
    if (this.pageType == 1) { // 期权
      this.initOption()
      this.initReport()
    } else if (this.pageType == 4) { // 金融
      this.initLog()
    } else if (this.pageType == 6 ) { //跟单
      // this.initEchart()
    } else if (this.pageType == 2) { // 合约
      this.initContract()
    }
   
  },
  methods: {
    initRate() {
			monetaryList().then(res => {
				this.allRateList = res.data.Items || []
			})
		},
    initReport() {
      let form = new FormData()
      form.append('StartDate', moment().startOf('month').format('YYYY-MM-DD'))
      form.append('EndDate', moment().endOf('month').format('YYYY-MM-DD'))
      // 本月报表
      accountReport(form).then(res => {
        let data  = res.data.Items
        if (this.pageType == 1) { //期权
          let list = this.resetData('OptionProfitAmount', 'OptionTransactionNum', 'OptionTransactionVolume', data)
          list.reverse()
          this.initEchart(list)
          this.initTotalEchart('chartDom2', list)
        } else {// 跟单

        }
      })
      //上月报表
      let form2 = new FormData()
      form2.append('StartDate', moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
      form2.append('EndDate', moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'))
      accountReport(form2).then(res => {
        let data  = res.data.Items
        if (this.pageType == 1) { //期权
          let list = this.resetData('OptionProfitAmount', 'OptionTransactionNum', 'OptionTransactionVolume', data)
          this.initTotalEchart('chartDom3', list)
        } else {// 跟单

        }
      })
    },
    resetData(key1, key2, key3, data) {
      let list = []
      data.forEach(v => {
        let date = v.Day
        let index = list.findIndex(val => {
          return date == val.date
        })
        if (index > -1) {
          list[index].val += v[key1]
          list[index].count += v[key2]
          list[index].total += v[key3]
        } else {
          list.push({
            date,
            val: v[key1],
            count: v[key2],
            total: v[key3]
          })
        }
      })
      return list
    },
    init() {
      myAssets({
        Unit: 'USDT'
      }).then(res => {
        let data = res.data
        if (this.pageType == 1) { // 期权
          this.userMoney = parseFloat(data.Option).toFixed(4)
        } else if (this.pageType == 3) { // 现货
          this.userMoney = parseFloat(data.Spot).toFixed(4)
        } else if (this.pageType == 4) { // 金融
          this.userMoney = parseFloat(data.Finance).toFixed(4)
        } else if (this.pageType == 5) { // 资金
          this.userMoney = parseFloat(data.Total).toFixed(4)
        } else if (this.pageType == 6) { // 跟单
          this.userMoney = parseFloat(data.Finance).toFixed(4)
        }

      
      })
    },
    initContract() {
      contractOverview().then(res => {
        let data = res.data
        this.userMoney = parseFloat(data.ContractValuation).toFixed(4)
        

        this.freeMoney =  parseFloat(data.PositionAmount).toFixed(4)
      })
    },
    initWallet() {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', 10)
      form.append('ShortName', '')
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          if (this.pageType == 1) { // 期权
            this.moneyUse = parseFloat(data.OptionUse).toFixed(4)
          } else if (this.pageType == 2) { // 合约
            this.moneyUse = parseFloat(data.ContractUse).toFixed(4)
          } else if (this.pageType == 3) { // 现货
            this.moneyUse = parseFloat(data.SpotUse).toFixed(4)
          } else if (this.pageType == 4) { // 金融
            this.moneyUse = parseFloat(data.FinanceUse).toFixed(4)
          } else if (this.pageType == 5) { // 资金
            this.moneyUse = parseFloat(data.CapitalUse).toFixed(4)
          } else if (this.pageType == 6) { // 跟单
            this.moneyUse = parseFloat(data.FinanceUse).toFixed(4)
          }
        }

        // 资产
        if (this.pageType == 2 || this.pageType == 3) {
          let list = res.data.Items.filter(v => {
            return v.Currency.ShortName != 'USDT'
          })
          this.bitList = list
          this.page.total = res.data.Pagination.totalRecords
        }
      })
    },
    initOption() {
      optionReport().then(res => {
        this.optionReportData= res.data
        this.freeMoney = res.data.WaitSettlement ? res.data.WaitSettlement.toFixed(2) : '0.00'
      })
    },
    getUserKey() {
      let key = ''
      switch (this.pageType + '') {
        case '1': key = 'SpotUse'; break;
        case '2': key = 'ContractUse'; break;
        case '3': key = 'OptionUse'; break;
        case '4': key = 'FinanceUse'; break;
        case '5': key = 'CapitalUse'; break;
        default: break;
      }
      return key
    },
    getFeeKey() {
      let key = ''
      switch (this.pageType + '') {
        case '1': key = 'SpotFree'; break;
        case '2': key = 'ContractFree'; break;
        case '3': key = 'OptionFree'; break;
        case '4': key = 'FinanceFree'; break;
        case '5': key = 'CapitalFree'; break;
        default: break;
      }
      return key
    },
    changePage(page) {
      this.page.page = page
      if (this.pageType == 4) {
        this.initLog()
      } else {
        this.initWallet()
      }
    },
    initLog() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      financeList(form).then(res => {
        this.ownerFinanceList = res.data.Items
        this.page.total = res.data.Pagination.totalRecords
        this.logList = this.ownerFinanceList.filter(v => {
          return v.FinancialSetup.ProductType == this.financeIndex
        })
      })
    },
    initEchart(data) {
      var chartDom1 = echarts.init(document.getElementById('chartDom1'));
      let charData = data.map(v => {
        return v.val
      })
      let xAxis = data.map(v => {
        return v.date.substring(5)
      })
      const option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (e) => {
            let obj = e[0]
            let index = obj.dataIndex
            let format = ''
            let count = data[index].count
            format += '<span>' + this.$t('account.tooltipIncome') + '</span>'
            format += '<span>' + obj.data + '</span>'
            format += '<br>'
            format += '<span>' + this.$t('account.tooltipTrades') + '</span>'
            format += '<span>' + count + '</span>'
            return format 
          }
        },
        calculable: true,
        grid: {
          top: 40,
          right: 30,
          bottom: 40,
          left: 70
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: xAxis,
          axisLabel: {
            color: '#615E83'
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#615E83'
          },
          splitLine: {
            lineStyle: {
              color: '#f1f1f1'
            }
          }
        },
        series: [
          {
            name: this.$t('shou-yi-jin-e'),
            type: 'bar',
            barMaxWidth: '20',
            data: charData,
            itemStyle: {
              normal: {
                color: (e) => {
                  return e.data > 0 ? '#07C67B' : '#EB5757'
                }
              }
            }
          }
        ]
      };
      chartDom1.setOption(option);
      this.chartDom1 = chartDom1
    },
    getTitle(isNow) {
      return isNow ? moment().format(this.$t('account.dateFormat')) : moment().subtract(1, 'months').format(this.$t('account.dateFormat'))
    },
    initTotalEchart(key, data) {
      // 底部chart
      var chartDom = echarts.init(document.getElementById(key));
      let total = 0
      let profit = 0
      let count = 0
      data.forEach(v => {
        total += v.total
        profit += v.val
        count += v.count
      })
      let charData2 = [total, profit]
      let xAxis2 = [this.$t('jiao-yi-zong-e'), this.$t('jiao-yi-ying-kui')]
      const option2 = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          formatter: (e) => {
            let format = ''
            let obj = e[0]
            let index = obj.dataIndex
            if (index == 0) {
              format += '<span>' + this.$t('account.tooltipTotalAmount') + '</span>'
              format += '<span>' + total + '</span>'
              format += '<br>'
              format += '<span>' + this.$t('account.tooltipTrades') + '</span>'
              format += '<span>' + count + '</span>'
            } else {
              format += '<span>' + this.$t('account.tooltipProfitLoss') + '</span>'
              format += '<span>' + profit + '</span>'
            }
            return format 
          }
        },
        calculable: true,
        grid: {
          top: 20,
          right: 30,
          bottom: 40,
          left: 70
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: xAxis2,
          axisLabel: {
            color: '#000000'
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#615E83'
          },
          splitLine: {
            lineStyle: {
              color: '#f1f1f1'
            }
          }
        },
        series: [
          {
            name: this.$t('shou-yi-jin-e-0'),
            type: 'bar',
            barMaxWidth: '30',
            data: charData2,
            itemStyle: {
              normal: {
                color: (e) => {
                  let index = e.dataIndex
                  return index == 0 ? '#056FFA' : e.data > 0 ? '#07C67B' : '#EB5757'
                }
              }
            }
          }
        ]
      };

      chartDom.setOption(option2);
      this[key] = key
    },
    back() {
			this.$router.go(-1)
		},
    toLog() {
			this.$router.push({
				name: 'assestLog',
			})
		},
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    changeBit() {
      this.showBitPage = true
    },
    cancel() {
      this.showBitPage = false
      this.showRecharge = false
    },
    resetSpotMoney(count, id) {
      let index = this.allTradesData.findIndex(v => {
        return v.CurrencyId == id
      })
      if (index > -1) {
        let price = this.allTradesData[index].Price
        return parseFloat(price * count).toFixed(4)
      } else {
        return parseFloat(count).toFixed(4)
      }
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    clearSearch() {
      this.form.keyword = ''
      this.bitList = [].concat(this.bitListBak)
    },
    searchBit() {
      this.bitList = this.bitListBak.filter(v => {
        return v.Currency.ShortName.toLowerCase().indexOf(this.form.keyword) > -1
      })
    },
    changeShowType() {
      this.showZero = !this.showZero
      let filterList = ['USDT']
      if (this.form.keyword) {
        this.bitList = this.bitListBak.filter(v => {
          let userKey = this.getUserKey()
          let feeKey = this.getFeeKey()
          return (parseFloat(v[userKey]) != 0 || parseFloat(v[feeKey]) != 0 || this.showZero) && v.Currency.Name.toLowerCase().indexOf(this.form.keyword) > -1
        })
      } else {
        this.bitList = this.bitListBak.filter(v => {
          let userKey = this.getUserKey()
          let feeKey = this.getFeeKey()
          return (parseFloat(v[userKey]) != 0 || parseFloat(v[feeKey]) != 0) || this.showZero
        })
      }
    },
    changeBitTab(i) {
      this.bitTabIndex = i
    },
     toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toWithdraw() {
      if (this.realNameStatus == '2') {
        this.toPath('withdraw')
      } else if (this.realNameStatus == '1') {
        this.$store.state.warningMsg = this.i18n.t('setting.desc8')
      } else {
        this.toPath('withdraw')
      }
    },
    toLog() {
     
      this.$router.push({
        name: 'assestLog',
        query: {
          type: this.pageType
        }
      })
    },
    resetBitMoney(money, ShortName) {
			let rate = 1
      // 获取bit价格
      let index = this.allBitList.findIndex(v => {
        return v.ShortName == ShortName
      })
      if (index > -1) {
        rate = this.allBitList[index].count || 1
      }
			return (money * rate).toFixed(4)
		},
    toTransfer() {
			let type = 1
			if (this.pageType == 1) {//期权
				type = 2
			} else if (this.pageType == 2) {//合约
				type = 3
			} else if (this.pageType == 3) { // 现货
				type = 4
			} else if (this.pageType == 4) { // 金融
				type = 5
			} else if (this.pageType == 6) { // 跟单
				type = 6
			}
			this.$router.push({
				name: 'transfer',
				query: {
					type: type
				}
			})
		},
    changeFinanceTab(i) {
      this.financeIndex = i
      this.logList = this.ownerFinanceList.filter(v => {
        return v.FinancialSetup.ProductType == this.financeIndex
      })
    },
    toTrade(data, type) {
      this.$router.push({
        name: 'trade',
        query: {
          name: data.Currency.ShortName,
          id: data.Currency.ID,
          type: type || 2
        }
      })
    }
  }
}
</script>